<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="page-main">
      <div class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="$router.go(-1)"></el-button>
        <span class="se-panel-title z-padding-left-5-precent ver-sub">免费延期申请</span>
      </div>
      <div class="panel-body clearfix">
        <div class="alert-warn">
          1、为了节约系统资源，保留活跃用户，进一步发展免费空间以及云服务器，我们采用了定期申请延期的方案。<br>
          2、免费产品每次延期后新的到期时间为：<br>
          <span class="z-margin-left-15-precent">免费空间开通后，默认 <span class="z-color-a">30</span>天使用时间，每次延期审核通过后自审核之时计算 <span class="z-color-a">加三十天</span>时间</span><br>
          3、免费产品没有数据保留功能，到期后会自动删除，请及时备份程序和数据到本地。<br>
          4、延期规则：<span class="z-color-a">请在下方点击延期。</span><br>
          <span class="z-margin-left-15-precent">延期申请链接：
            <a v-for="item in post_addr" :href="item.href" class="z-color-a z-curPonit a-underline-link z-margin-right-5-precent" target="_blank">{{item.title}}</a>
          </span><br>
          5、发表后请在 <span class="z-color-a">一小时内</span>把您发表的发帖地址和发帖截图在下方提交，工作时间2小时审核完成
        </div>
        <el-form ref="cardForm" label-width="120px" class="clearfix">
          <el-form-item label="发帖地址：">
            <el-input v-model="cardForm.url" placeholder="请输入发帖网址http://" style="width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="发帖截图：">
            <div class="ub-box">
              <div class="ub-box">
                <div class="col-img">
                  <label for="fileImg1" class="z-curPonit">
                    <img v-show="!showimg" src="../../assets/imgs/img3.png" alt="请上传现场图片" width="135" height="102">
                  </label>
                  <label for="fileImg1" class="z-curPonit">
                    <img v-show="showimg" :src="dataUrl" width="135" height="102"/>
                  </label>
                </div>
              </div>
              <div class="z-margin-left-15-precent">
                <p class="gff8 z-font-size-14">JPG或PNG格式</p>
                <p class="z-font-size-12 z-color-999 z-padding-bottom-5-precent">请上传发帖截图</p>
                <label for="fileImg1" class="choose-file">选择文件</label>
                <input type="file" id="fileImg1" name="CertImg" @change="handleFileChange" ref="inputer" class="z-width-30-precent" style="visibility: hidden;">
              </div>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="submitrForm">提交</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table :data="cardList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="id" label="序号" align="left">
            <template slot-scope="scope">
              <span class="z-padding-left-5-precent">{{scope.row.id}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="网址" min-width="200" align="left">
            <template slot-scope="scope">
              <a :href="scope.row.Url" class="z-color-a z-curPonit a-underline-link" target="_blank">{{scope.row.Url}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="SetTime" label="提交时间" align="left">
          </el-table-column>
          <el-table-column prop="CheckTime" label="审核时间" align="left">
          </el-table-column>
          <el-table-column prop="State" label="状态" align="left">
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示信息"
      :visible.sync="dialogSuccess"
      top="20%"
      width="420px"
      :close-on-click-modal=false
      :close-on-press-escape=false
      custom-class="dialog"
      @close="dialogSuccessClose">
      <img style="margin-left: 30px;vertical-align: middle" src="../../assets/imgs/uc_success.png" alt="">
      <span class="z-font-size-14 z-margin-left-5-precent">{{dialogSuccessMsg}}</span>
      <span slot="footer" class="dialog-footer">
          </span>
    </el-dialog>
  </div>
</template>
<script>
  import renewService from 'business/renewService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  export default {
    data() {
      return {
        listLoading:false,
        dialogLoading:false,
        dialogSuccess:false,
        dialogSuccessMsg:'',
        post_addr:[],
        cardList: [],
        cardForm:{
          url:''
        },
        dataUrl:'',
        showimg:false,
        count:10,
        total:0,
        page:1,
      }
    },
    props:{
      hide:Boolean
    },
    components:{
      XdialogLoading
    },
    mounted() {
      this.SearchCard()
    },
    methods:{
      async submitrForm() {
        this.dialogLoading = true
        let formData = new window.FormData();
        formData.append('cmd', 'free_delay_add')
        formData.append('url', this.cardForm.url)
        formData.append('yanqi_img', this.$refs.inputer.files[0])
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',formData)
        if(vueData.response == 200 ) {
          this.showimg = false
          this.dialogLoading = false
          this.dialogSuccessMsg = vueData.msg
          this.dialogSuccess = true
          setTimeout(() => {
            this.dialogSuccess = false
          },2000)
        }else {
          this.dialogLoading = false
          this.$toast(vueData.msg,'fail')
        }
      },
      async SearchCard() {
        this.listLoading = true
        let data = 'cmd=free_delay_list'+'&count='+ this.count +'&page='+ this.page
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.post_addr = vueData.post_addr
          this.total = vueData.msg.allcount
          this.cardList = vueData.msg.content.map((item, index) => {
            return {
              id:index + 1,
              Url:item.Url,
              SetTime:item.SetTime,
              CheckTime:item.CheckTime,
              State:item.State,
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchBeian()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchBeian()
      },
      imgPreview (file) {
        let self = this;
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader();
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            self.dataUrl = this.result;
          }
        }
        this.showimg = true
      },
      handleFileChange () {
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file  = inputDOM.files[0];
        // 这里就可以获取到文件的名字了
        this.fileName = this.file.name;

        this.imgPreview(this.file);
      },
      dialogSuccessClose() {
        this.SearchCard()
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .page {
    margin-top: 45px;
    width: 100%;
    background-color: #fff;
  }
  .page-main { border: 0}
  .panel-heading { padding: 5px 0 0 0; }
  .alert-warn {
    margin-bottom: 20px;
  }
  .col-img {
    border: solid 1px #bbbaba;
    width: 135px;
    height: 102px;
    border-radius: 3px;
    margin-right: 10px;
  }
  .choose-file {
    display: inline-block;
    position: absolute;
    padding: 4px 12px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    border-color: #2082dd;
    background-color: #2a89e0;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/vhostDelay.vue